// PRD 11 §3.6 Text block — title input + WYSIWYG body. Owns no state — the
// parent passes the current block and receives partial updates via `onChange`.
// ADM.016: body is 1~500 chars counted on PLAIN text; a live counter warns
// before the publish-time validation bites. Block chrome is owned by
// ContentBlockList.

import { useTranslation } from 'react-i18next';

import type { ContentBlock } from '../types/counseling-manual.types';
import { BLOCK_TITLE_MAX, plainTextLength, TEXT_BLOCK_MAX } from '../utils/validate-form';
import { RichTextEditor } from './RichTextEditor';

interface TextBlockEditorProps {
  block: ContentBlock;
  disabled?: boolean;
  onChange: (patch: Partial<ContentBlock>) => void;
}

export function TextBlockEditor({ block, disabled = false, onChange }: TextBlockEditorProps) {
  const { t } = useTranslation('counseling-manual');
  const count = plainTextLength(block.text);
  const over = count > TEXT_BLOCK_MAX;

  return (
    <>
      <input
        type="text"
        className="form-field__input"
        value={block.title}
        onChange={(e) => onChange({ title: e.target.value })}
        placeholder={t('blocks.titlePlaceholder')}
        maxLength={BLOCK_TITLE_MAX}
        disabled={disabled}
        style={{ marginBottom: 6 }}
      />

      <RichTextEditor
        blockId={block.id}
        value={block.text}
        onChange={(html) => onChange({ text: html })}
        placeholder={t('blocks.bodyPlaceholder')}
        readOnly={disabled}
      />
      <div
        style={{
          textAlign: 'right',
          fontSize: 12,
          marginTop: 4,
          color: over ? 'var(--destructive)' : 'var(--muted-foreground)',
        }}
      >
        {count}/{TEXT_BLOCK_MAX}
      </div>
    </>
  );
}
